import React from "react";
import './Login.css'
import { Link} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
// import useAuth from "../../Hooks/UseAuth";

const Login = () => {
  const {
    signInWithEmail,
    googleSignIn,
    userEmail,
    userPassword,
    error,
  } = useAuth();
 
  
  return (
    <div className=" login w-25 m-auto p-3 mt-3 border rounded ">
      <h2 className="  text-secondary mb-3">Please, Log in</h2>
      <div className="  text-danger" style={{ height: "50px" }}>
        {error}
      </div>
      <form className="">
        <input
          onChange={userEmail}
          className="form-control mb-3"
          type="email"
          name=""
          id=""
          placeholder="E-mail"
        />
        <input
          onChange={userPassword}
          className="form-control mb-3"
          type="password"
          name=""
          id=""
          placeholder="Password"
        />
        <input
          onClick={signInWithEmail}
          className="btn btn-secondary mb-3"
          type="submit"
          value="Login"
        
        />
        <input className="btn btn-info mb-3 mx-2" type="reset" defaultValue="Reset"/>
      </form>
      <p>Or</p>
      <p className="text-secondary">Sign in with</p>
      <button onClick={googleSignIn} className="btn btn-success me-2">
        Google
      </button>
      <p className="mt-3">
        New user? <Link className="text-decoration-none" to="/register">Register here</Link>
      </p>
    </div>
  );
};

export default Login;

